import React from 'react'

import { faCoins } from '@fortawesome/pro-regular-svg-icons/faCoins'
import { faCoins as faListCheckSolid } from '@fortawesome/pro-solid-svg-icons/faCoins'

import MainMenuItem from 'src/components/Menu/MainMenuItem'

import useTranslations from 'src/hooks/useTranslations'
import { reverse } from 'src/routes/config'

export default function ExpensesMenu({ parentIsCollapsed }) {
    const { t } = useTranslations('ExpensesMenu', 'ExpensesMenu')

    return (
        <MainMenuItem
            icon={faCoins}
            iconActive={faListCheckSolid}
            title={t('Expenses')}
            to={reverse('expenses')}
            parentIsCollapsed={parentIsCollapsed}
        />
    )
}
